import { marked } from "marked";

marked.setOptions({ gfm: true, breaks: true });

/**
 * Renders answer markdown. All HTML is escaped before parsing, so nothing that came
 * back through a tool result can inject markup — Phase 1 rendered text-only for the
 * same reason; mAImu keeps the guarantee while still rendering markdown.
 */
export function renderMarkdown(text: string): string {
  const escaped = text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  return marked.parse(escaped, { async: false });
}
